import type { Task } from "@app/core";
import { create } from "zustand";

export type SeriesChoice = "single" | "series" | "all" | "cancel";

export type PendingChange =
  | {
      kind: "reschedule";
      task: Task;
      sourceId: string;
      oldOccurrence: string;
      newDueAt: string;
      /** True for virtual occurrences. Source-task drops can only "Apply to series". */
      isVirtual: boolean;
    }
  | {
      kind: "resize";
      task: Task;
      sourceId: string;
      newDurationMinutes: number;
      isVirtual: boolean;
    }
  | {
      kind: "convert-all-day";
      task: Task;
      sourceId: string;
      oldOccurrence: string;
      newDueAt: string;
      newDurationMinutes: number;
      isVirtual: boolean;
    }
  | {
      kind: "rename";
      task: Task;
      sourceId: string;
      newTitle: string;
    }
  | {
      kind: "edit";
      task: Task;
      sourceId: string;
    }
  | {
      kind: "delete";
      task: Task;
      sourceId: string;
      occurrenceIso: string;
      isVirtual: boolean;
    };

interface State {
  open: boolean;
  pending: PendingChange | null;
  resolveFn: ((choice: SeriesChoice) => void) | null;
  ask: (pending: PendingChange) => Promise<SeriesChoice>;
  resolve: (choice: SeriesChoice) => void;
}

export const useRecurringConfirmStore = create<State>((set, get) => ({
  open: false,
  pending: null,
  resolveFn: null,
  ask: (pending) =>
    new Promise((resolve) => {
      set({ open: true, pending, resolveFn: resolve });
    }),
  resolve: (choice) => {
    const fn = get().resolveFn;
    set({ open: false, pending: null, resolveFn: null });
    fn?.(choice);
  },
}));
